import './DocumentDeliverySectionHeader.scss';

import PropTypes from 'prop-types';
import React from 'react';

const DocumentDeliverySectionHeader = ({ sectionHeader }) => {
  return (
    <div className="document-delivery-section-header-container">
      <h2 className="document-delivery-section-header">{sectionHeader}</h2>
    </div>
  );
};

DocumentDeliverySectionHeader.propTypes = {
  sectionHeader: PropTypes.string.isRequired,
  showToggleAll: PropTypes.bool
};

export default DocumentDeliverySectionHeader;
